import { HomePage, App } from '@mc/newsroom'
import { useRouter } from 'next/router'
import { CSR } from 'components/CSR'

const NewsroomPage = () => {
  const { asPath } = useRouter()
  return (
    <CSR>
      <App asPath={asPath}>
        <HomePage />
      </App>
    </CSR>
  )
}

export const getServerSideProps = async () => ({ props: {} })

NewsroomPage.pageSettings = {
  rumLabel: 'Newsroom',
  analyticsLabel: 'Self Serve',
  hideNavigation: true,
}

export default NewsroomPage
